import { GET_INTERCOM_ACTION, GET_INTERCOM_TARIFFS } from '~/src/store/actionTypes/intercom';
import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';

export interface IntercomActionInfo {
    id: number,
    description: string,
    available: number,
    city_id: number
}

export interface InteromTariffItem {
    id: number,
    available: number,
    name: string,
    available_new: number,
    available_auth: number,
    price: number,
    billing_price: number,
    city_id: number,
    tariff_id: number,
    billing_city_id: number,
    plan_group_id: number,
    key_count: number
}

export interface IIntercomState {
    actionInfo: IntercomActionInfo,
    tariffs: InteromTariffItem[] | [],
}

export enum IntercomActionTypes {
    GET_INTERCOM_TARIFFS = 'GET_INTERCOM_TARIFFS',
    GET_INTERCOM_ACTION = 'GET_INTERCOM_ACTION',
}

export type TActions = {
    type: IntercomActionTypes,
    payload: Partial<IIntercomState>,
};

const initialState: IIntercomState = {
    tariffs: [],
    actionInfo: {
        id: 0,
        description: 'Открывайте домофон, общайтесь с посетителями ' +
            'и&nbsp;просматривайте видео с придомовой территории через приложение на смартфоне',
        available: 1,
        city_id: 0,
    },
};

export default (state: IIntercomState = initialState, action: TActions | THydrateAction) => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.intercom };
        case GET_INTERCOM_TARIFFS: {
            const tariffs = action.payload;
            return {
                ...state,
                tariffs: tariffs,
            };
        }
        case GET_INTERCOM_ACTION: {
            const actionInfo = action.payload;
            return {
                ...state,
                actionInfo: actionInfo,
            };
        }
        default: {
            return state;
        }
    }
};
